import "../../../../content/blog/2017-09-08-dive-into-graphql-part-v-should-you-use-graphql.css";
import React from 'react';
export default {
  React
};